export default [
  {
    sortType: 'Newest',
    id: 'newest'
  },
  {
    sortType: 'Oldest',
    id: 'oldest'
  },
  {
    sortType: 'Least Expensive to Most',
    id: 'pra'
  },
  {
    sortType: 'Most Expensive to Least',
    id: 'prd'
  },
  {
    sortType: 'Bedrooms (Low to High)',
    id: 'bda'
  },
  {
    sortType: 'Bedrooms (High to Low)',
    id: 'bdd'
  },
  {
    sortType: 'Bathrooms (Low to High)',
    id: 'tba'
  },
  {
    sortType: 'Bathrooms (High to Low)',
    id: 'tbd'
  }
];
